"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
exports.Status = function (_a) {
    var code = _a.code, children = _a.children;
    return (react_1.default.createElement(react_router_dom_1.Route, { render: function (_a) {
            var staticContext = _a.staticContext;
            if (staticContext) {
                staticContext.statusCode = code;
            }
            return children;
        } }));
};
exports.NotFoundPage = function () {
    return (react_1.default.createElement(exports.Status, { code: 404 },
        react_1.default.createElement("h2", { className: "not-found" }, "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430")));
};
exports.Meta = function (_a) {
    var meta = _a.meta;
    return (react_1.default.createElement(react_router_dom_1.Route, { render: function (_a) {
            var staticContext = _a.staticContext;
            if (staticContext) {
                staticContext.meta = meta;
            }
            return null;
        } }));
};
